var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelSelectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4839 5.84619C12.4839 5.84619 12.9006 6.26286 13.3172 7.09619C13.3172 7.09619 14.6407 5.01286 15.8172 4.59619",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32888 1.6845C6.24682 1.59635 4.63827 1.8362 4.63827 1.8362C3.62256 1.90883 1.67605 2.47826 1.67607 5.80384C1.67609 9.10114 1.65454 13.1661 1.67607 14.7866C1.67607 15.7767 2.28909 18.0861 4.41089 18.2099C6.98992 18.3604 11.6355 18.3924 13.7669 18.2099C14.3375 18.1777 16.237 17.7298 16.4775 15.6631C16.7265 13.522 16.677 12.034 16.677 11.6798",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.333 5.84635C18.333 8.14754 16.4658 10.0131 14.1624 10.0131C11.8589 10.0131 9.9917 8.14754 9.9917 5.84635C9.9917 3.54517 11.8589 1.67969 14.1624 1.67969C16.4658 1.67969 18.333 3.54517 18.333 5.84635Z",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81689 10.8462H9.1502",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81689 14.1797H12.4835",
    stroke: "#626262",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelSelectionIcon);
export default __webpack_public_path__ + "static/media/model-selection-icon.31bd7f5cf16da363e6f7f608a96e2b89.svg";
export { ForwardRef as ReactComponent };